import React from "react";

export default function InsightTableDetailRow(props) {
  return <div>Tell me more, yo</div>;
}
